import styled from 'styled-components';

export const AmountWrap = styled.div`
  .checkbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.2rem;
    margin-top: 1rem;
    gap: 0.6rem;
  }
  .service-view {
    cursor: pointer;
    text-decoration: underline;
    :hover {
      color: ${(props) => props.theme.colors.main};
    }
  }
`;
